module.exports = ".pagination li,\nth {\n  cursor: pointer; }\n\n.sorting {\n  opacity: 0.8;\n  font-size: 12px; }\n\n.active {\n  color: #000000; }\n\n.inactive {\n  color: #b7b7b7; }\n\n.cell-wrapper {\n  display: block;\n  width: 90px; }\n\n.color-alert--red {\n  background: #f2dede; }\n\n.color-alert--yellow {\n  background: #fcf3bf; }\n\n.filters {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: baseline;\n      -ms-flex-align: baseline;\n          align-items: baseline; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/table/table.component.scss
// module id = ./src/app/shared/table/table.component.scss
// module chunks = main